var _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgFilter(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    viewBox: "0 0 7 7",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_871",
    "data-name": "Group 871",
    transform: "translate(-1.162 -6.784)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_433",
    "data-name": "Group 433",
    transform: "translate(1 10.417)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1792",
    "data-name": "Rectangle 1792",
    width: 7,
    height: 1,
    rx: 0.5,
    transform: "translate(0.162 1.366)"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1793",
    "data-name": "Rectangle 1793",
    width: 1,
    height: 3,
    rx: 0.5,
    transform: "translate(2.162 0.366)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_432",
    "data-name": "Group 432",
    transform: "translate(1 7.151)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1789",
    "data-name": "Rectangle 1789",
    width: 7,
    height: 1,
    rx: 0.5,
    transform: "translate(0.162 0.634)"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1794",
    "data-name": "Rectangle 1794",
    width: 1,
    height: 3,
    rx: 0.5,
    transform: "translate(4.162 -0.366)"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFilter);
export default __webpack_public_path__ + "static/media/filter.5eb0e494.svg";
export { ForwardRef as ReactComponent };